import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import { captureAffiliateId } from '@link/share/utils';

// The framework's default client entry, plus the one piece of the SPA's
// `src/main.tsx` that has to run before React does: capturing the affiliate tag
// off the entry URL. See share/utils/affiliateId for why it lives here
// rather than in a loader or an effect.
captureAffiliateId();

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
